import React from 'react'
import PropTypes from 'prop-types'
import { ContainerModal } from './styles'

const ConfirmationModal = ({
  isOpen,
  onRequestClose,
  style,
  contentlabel,
  children,
  transparent,
}) => (
  <ContainerModal
    isOpen={isOpen}
    onBackgroundClick={onRequestClose}
    style={style}
    contentlabel={contentlabel}
    backgroundProps={{
      style: {
        backgroundColor: transparent && 'transparent',
      },
    }}
  >
    {children}
  </ContainerModal>
)

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  style: PropTypes.object,
  contentlabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  transparent: PropTypes.bool,
}

ConfirmationModal.defaultProps = {
  style: {},
  transparent: false,
}

export default ConfirmationModal
